import CashierServiceModel from "../CashierServiceModel";

export default class InvoiceItemModel extends CashierServiceModel {
  modelName() {
    return 'invoice-items';
  }
  defaults() {
    return {
      id: null,
      stripe_id: null,
      user_id: null,
      user: null,
      customer_id: null,
      customer: null,
      invoice_id: null,
      invoice: null,
      currency: null,
      amount: null,
      description: null,
      discountable: null,
      metadata: null,
      quantity: null,
      unit_amount: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      stripe_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      invoice_id: (val) => (this.nullStringMutator(val)),
      currency: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      discountable: Boolean,
      metadata: (val) => (this.nullStringMutator(val)),
      quantity: Number,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }
  validation() {
    return {}
  }

}
